import {observable, action } from 'mobx'

class Purchased {

  @observable
  currentPage = 1;

  @observable purchaseCompleted = true;

  @observable redirectedToPurchase = false;

  @observable totalPages = 1;

  @action setRedirectedToPurchase = () => {
    this.redirectedToPurchase - true;
  }

  @action clearRedirectedToPurchase = () => {
    this.redirectedToPurchase - false;
  }

  @action setPage = page => {
    this.currentPage = page;
  };

  @action setTotalPages = page => {
    this.totalPages = page;
  };

  @action setInitialState = () => {
    this.currentPage = 1;
    this.totalPages = 1;
  }

  @action onPurchaseCompleted = () => {
    this.purchaseCompleted = true;
  }

  @action offPurchaseCompleted = () => {
    this.purchaseCompleted = false;
  }

}

export default new Purchased();



// WEBPACK FOOTER //
// ./src/stores/Purchased.js